/**
 * webfonts.js
 *
 * Load Webfonts to use on the site. Uses the Web Font Loader asynchronously.
 *
 * You can set your default Font Stack in scss/_settings.scss.
 * Documentation: https://github.com/typekit/webfontloader and https://developers.google.com/speed/libraries/devguide#webfont
 */

WebFontConfig = {
	google: { families: [ 'Lato:400,700' ] },
	monotype: {
	    projectId: 'bee66025-e503-4924-9bd1-01beb3d5746d',
	    version: 12345, // (optional, flushes the CDN cache)
	    loadAllFonts: true //(optional, loads all project fonts)
	}
};

(function() {
	var wf = document.createElement('script');
	wf.src = ('https:' === document.location.protocol ? 'https' : 'http') +
			'://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
	wf.type = 'text/javascript';
	wf.async = 'true';
	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(wf, s);
})();
